<template>
  <ion-modal :is-open="isOpen" :backdrop-dismiss="true" :show-backdrop="true" @didDismiss="close">
    <ion-content style="--ion-background-color: #78004c;">
      <ion-button color="transparent" class="top-right" @click.prevent="close">
        <i class="ti-close" />
      </ion-button>
      <section class="ar-modal-container">
        <p v-if="counter && counter <= 12" class="bold">{{counter}} of 12</p>
        <div v-if="counter <= 12" class="roulette-container">
          <art-roulette class="roulette" @select="onSelect"/>
        </div>
        <div v-else class="finish-msg text-center h-100">
          <div class="bumper2"></div>
          <p class="big">🎉</p>
          <p>Hooray! You're Done!</p>
          <p>Come back later to play with more art.</p> 
          <h3 v-if="endsAt" class="counter mt-3">
            <vue-countdown v-slot="{ days, hours, minutes, seconds }" :time="endsAt" @end="onEnd">
              <span class="white"><span v-if="hours">{{ hours }}:</span><span v-if="!days"><span v-show="minutes < 10">0</span>{{ minutes }}</span><span v-if="!days && !hours">:<span v-show="seconds < 10">0</span>{{ seconds }}</span></span>
            </vue-countdown>
          </h3>
        </div>
        <ion-button v-if="!counter || counter>12" color="dark" size="medium" class="close-bottom" @click="close"><span class="no-select">Close</span></ion-button>
      </section>
    </ion-content>
  </ion-modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IonModal, IonContent, IonTitle } from '@ionic/vue';
import ArtRoulette from '@/pages/home/components/ArtRoulette.vue';
import { getRepeatedEventProgress } from '@/actions/events';
import { formatFromNowInMilliseconds } from '@/utils/dateTime';

interface Data {
  counter: number;
  endsAt: number;
};

export default defineComponent({
  name: 'ArtRouletteModal',
  components: { ArtRoulette, IonModal, IonContent, IonTitle },
  props: {
    isOpen: {type: Boolean, required: true },
    close: { type: Function, required: true }
  },
  data() {
    return { 
      counter: 1,
      endsAt: 0
    } as Data;
  },
  watch: {
    async isOpen(newVal: boolean) {
      if (newVal) await this.fetchProgress();
    }
  },
  mounted() {
    this.fetchProgress();
  }, 
  methods: {
    onSelect() {
      this.counter++;
    },
    onEnd() {
      this.close!();
    },
    async fetchProgress() {
      const { count, ends_at } = await getRepeatedEventProgress('art-roulette');
      this.endsAt = formatFromNowInMilliseconds(ends_at);
      this.counter = count + 1;
    }
  }
})
</script>

<style scoped lang="sass">
.ar-modal-container
  width: 100%
  padding: 1rem 0 0 0
  text-align: center
  color: white
  overflow-y: none
.close-bottom
  margin-bottom: 2rem
  width: 200px
  left: 0
  right: 0
  margin-left: auto
  margin-right: auto
.roulette-container
  display: flex
  left: 0
  right: 0
  max-height: 100%
  margin: 0
  text-align: left
.bumper2
  height: 30% !important
.big
  font-size: 3rem
.top-right
  position: absolute
  top: 0.5rem
  right: 0.5rem
.roulette
  align-content: center
  justify-content: center
ion-modal
  @media screen and (max-width: 767px)
    --border-radius: 0 !important
ion-content
  --overflow: hidden
</style>
